import React, { useState } from "react";

const PaymentPopup: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState("full");

  const paymentOptions = [
    { label: "Full price", amount: "2.319,84€ now", value: "full" },
    { label: "50% advance", amount: "1.159,92€ now", value: "50" },
    { label: "30% advance", amount: "695,95€ now", value: "30" },
    { label: "20% advance", amount: "463,96€ now", value: "20" },
  ];

  return (
    <div className="modal d-block" tabIndex={-1} role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content text-center rounded-4">
          <div className="modal-body p-4">

            <h5 className="fw-bold">Choisir votre magasin que tu veux connecter </h5>
            <p className="text-muted small">
              vous avez plus que 1 magasin 
            </p>

            <div className="d-grid gap-2 mt-4">
              {paymentOptions.map((option) => (
                <button
                  key={option.value}
                  onClick={() => setSelectedOption(option.value)}
                  className={`btn btn-outline-dark d-flex justify-content-between align-items-center px-3 py-2 rounded-pill ${
                    selectedOption === option.value ? "active bg-dark text-white" : ""
                  }`}
                >
                  <small>{option.amount}</small>
                </button>
              ))}
            </div>

            <div className="d-flex justify-content-between mt-4">
              <button className="btn btn-light rounded-pill px-4">previous</button>
              <button className="btn btn-dark rounded-pill px-4">connecter</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentPopup;
